import { Heading } from "@ariakit/react";
import { ExternalLink, IndieTabletopClubLogo, useCurrentUser } from "@indietabletop/appkit";
import { interactiveText } from "@indietabletop/appkit/common.css.ts";
import type { ReactNode } from "react";
import { Link } from "wouter";
import { hrefs } from "../root-layout/fmt.tsx";
import { feature, features } from "./style.css.ts";

function Feature(props: { heading: string; info: ReactNode }) {
  const { heading, info } = props;

  return (
    <li className={feature.container}>
      <div className={feature.counter} />
      <div>
        <div className={feature.heading}>{heading}</div>
        <p className={feature.info}>{info}</p>
      </div>
    </li>
  );
}

export function FeaturesOverview() {
  const currentUser = useCurrentUser();

  return (
    <div className={features.container}>
      <Heading className={features.heading}>What&apos;s included?</Heading>

      <ol className={features.list}>
        <Feature
          heading="Hobgoblin PDF"
          info={
            <>
              The <em>Hobgoblin</em> rulebook in PDF format will be available for download inside
              the app immediately after purchase.{" "}
              <em>Optionally, you can also add your purchase to DriveThruRPG.</em>
            </>
          }
        />

        <Feature
          heading="In-app Rules Visibility"
          info={
            <>
              The visibility of all <em>core rules references</em> in the app will be unlocked. Bye
              bye squiggles!
            </>
          }
        />
      </ol>

      <div className={features.divider} />

      <p className={features.accountInfo}>
        An Indie Tabletop Club account is needed to unlock in-app features and allow for easy
        downloads.{" "}
        {currentUser ?
          <>
            Your current account (<em>{currentUser.email}</em>) will be used.
          </>
        : <>
            <Link
              className={interactiveText}
              href={hrefs.login({
                redirectTo: hrefs.buy({ note: "continuePurchase" }),
                backTo: hrefs.buy(),
              })}
            >
              Log in
            </Link>
            {" or "}
            <Link
              className={interactiveText}
              href={hrefs.join({
                redirectTo: hrefs.buy({ note: "continuePurchase" }),
                backTo: hrefs.buy(),
              })}
            >
              create a new account
            </Link>
            {" now."}
          </>
        }
      </p>

      <ExternalLink
        style={{ display: "contents" }}
        href={hrefs.itc({ content: "spacegits_features" })}
      >
        <IndieTabletopClubLogo className={features.itcLogo} />
      </ExternalLink>
    </div>
  );
}
